import { render } from "./Upload.vue?vue&type=template&id=3c606025"
import script from "./Upload.vue?vue&type=script&lang=js"
export * from "./Upload.vue?vue&type=script&lang=js"

import exportComponent from "/home/franck_boullier/Documents/bitbucket/exchange-app-admin-vue-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__